import React, { useContext, useEffect, useState } from 'react';
import usePostSideFilters from '../../../hooks/home/usePostSideFilters';
import { Language } from '../../../App';
import { 
  MdOutlineDynamicFeed, 
  MdOutlineArticle, 
  MdOutlinePoll, 
  MdOutlineSensors, 
  MdOutlineMedicalServices 
} from "react-icons/md";

const FeedMobileFilter = () => {
  const { lang } = useContext(Language);
  const { handleType, type, typesData } = usePostSideFilters();

  const handleTabClick = (tabType) => {
    handleType(tabType);
  };

  const getFilterIcon = (itemType, isActive) => {
    const iconSize = 16;
    if (isActive) {
      return (
        itemType === "all" ? <MdOutlineDynamicFeed size={iconSize} style={{ color: "#FFFFFF" }} /> :
        itemType === "posts" ? <MdOutlineArticle size={iconSize} style={{ color: "#FFFFFF" }} /> :
        itemType === "poll" ? <MdOutlinePoll size={iconSize} style={{ color: "#FFFFFF" }} /> :
        itemType === "webinar" ? <MdOutlineSensors size={iconSize} style={{ color: "#FFFFFF" }} /> :
        <MdOutlineMedicalServices size={iconSize} style={{ color: "#FFFFFF" }} />
      );
    }

    switch (itemType) {
      case "all":
        return <MdOutlineDynamicFeed size={iconSize} style={{ color: "#00BADA" }} />;
      case "posts":
        return <MdOutlineArticle size={iconSize} style={{ color: "#3B82F6" }} />;
      case "poll":
        return <MdOutlinePoll size={iconSize} style={{ color: "#F59E0B" }} />;
      case "webinar":
        return <MdOutlineSensors size={iconSize} style={{ color: "#EF4444" }} />;
      case "clinical-image":
        return <MdOutlineMedicalServices size={iconSize} style={{ color: "#10B981" }} />;
      default:
        return <MdOutlineDynamicFeed size={iconSize} style={{ color: "#00BADA" }} />;
    }
  };

  return (
    <nav
      className="d-flex flex-nowrap mb-2 scroll-hide overflow-auto d-xl-none align-items-center"
      style={{
        width: '100%',
        whiteSpace: 'nowrap',
        top: '68px',
        zIndex: 10,
        position: 'sticky',
        borderRadius: "9999px",
        background: "rgba(255, 255, 255, 0.96)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1.2px solid rgba(0, 186, 218, 0.28)",
        padding: "4px 6px",
        gap: "4px",
        boxShadow: "0px 4px 16px rgba(0, 186, 218, 0.08), 0px 1px 4px rgba(0, 0, 0, 0.02)",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      {typesData.map(({ text, type: itemType }) => {
        const isActive = itemType === type;
        const label = lang?.[text] || text.replace('_', ' ');

        return (
          <button
            key={itemType}
            onClick={() => handleTabClick(itemType)}
            className={`d-inline-flex align-items-center justify-content-center rounded-pill border-0 cursor ${
              isActive ? "" : "feed-row-hover"
            }`}
            style={{
              height: "34px",
              padding: "0 14px",
              gap: "7px",
              flex: "1 0 auto",
              minWidth: "fit-content",
              background: isActive
                ? "linear-gradient(135deg, #00C8E8 0%, #00BADA 100%)"
                : "transparent",
              color: isActive ? "#FFFFFF" : "#475569",
              boxShadow: isActive ? "0px 2px 8px rgba(0, 186, 218, 0.35)" : "none",
              fontSize: "12.5px",
              fontWeight: isActive ? "700" : "500",
              transition: "all 0.2s ease",
              lineHeight: 1,
            }}
            role="button"
            aria-label={`Filter by ${label}`}
          >
            <span
              className="d-inline-flex align-items-center justify-content-center flex-shrink-0"
              style={{ lineHeight: 1 }}
            >
              {getFilterIcon(itemType, isActive)}
            </span>
            <span
              className="text-truncate d-inline-flex align-items-center"
              style={{ lineHeight: 1 }}
            >
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default FeedMobileFilter;